import React, { useEffect, useState } from "react";
import ClipLoader from "react-spinners/ClipLoader"; 
import { useParams } from "react-router-dom";
import ourTeamData from "../../data/our-team.json";
import axiosClient from "../../api/axios";


export default function TeamMember() {
  const { id } = useParams();
  // const member = ourTeamData.members.find((m) => m.id === parseInt(id));

  const [member, setMember] = useState(null);
  const [loadingMember, setLoadingMember] = useState(true);

  const fetchMember = async () => {
    try {
      setLoadingMember(true)
      const response = await axiosClient.get(`/api/teams/${id}/`);

      setMember(response.data.data);
    } catch (error) {
      console.error("Failed to fetch teams", error);
    } finally {
      setLoadingMember(false); // Done loading
    }
  };

    useEffect(() => {
      fetchMember();
    }, []);

  if (loadingMember) {
    return (
      <div
        className="container py-5"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <ClipLoader color="#0d6efd" size={80} />
      </div>
    );
  }

  if (!member) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">Team member not found</div>
      </div>
    );
  }

  console.log("memver",member)

  return (
    <>
      <section className="team-single-section ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-sm-12 col-lg-5">
              <div className="team-single-img">
                <img
                  src={member.image_url}
                  alt={member.name}
                  className="img-fluid rounded shadow-sm"
                />
              </div>
            </div>
            <div className="col-md-12 col-sm-12 col-lg-6">
              <div className="team-single-text">
                <div className="team-name mb-4">
                  <h4 className="mb-1">{member.name}</h4>
                  <span>{member.role}</span>
                </div>

                <div className="text-content mt-20">
                  {member.descriptions.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>

                <ul className="team-single-info">
                  <li>
                    <strong>Email:</strong>{" "}
                    <a href={`mailto:${member.email}`} className="text-decoration-none">
                      {member.email}
                    </a>
                  </li>
                  <li className="mt-3">
                    <strong>Connect:</strong>
                    <div className="list-inline team-social social-icon mt-2">
                      {member.linkedin_url && (
                        <a 
                          href={member.linkedin_url} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="me-3 color-primary"
                        >
                          <span className="ti-linkedin"></span>
                        </a>
                      )}
                      {/* {member.socials.facebook !== "#/" && (
                        <a 
                          href={member.socials.facebook}
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="me-3 color-primary"
                        >
                          <span className="ti-facebook"></span>
                        </a>
                      )}
                      {member.socials.twitter !== "#/" && (
                        <a 
                          href={member.socials.twitter}
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="me-3 color-primary"
                        >
                          <span className="ti-twitter"></span>
                        </a>
                      )} */}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
